export enum NodeType {
  Element = 1,
  Attribute = 2,
  TextNode = 3,
  Comment = 8,
  Document = 9,
  DocumentFragment = 11
}